/**
 *
 * StudentworkMixin
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';
//import _ from 'lodash';

import { OSS_TIMER } from '@/constants';
import { swalWarning } from '@/utils/swal2';

export const StudentworkMixin = {
  name: 'StudentworkMixin',

  data: () => {
    return {
      itvlStudentworkOssPolicy: null,

      idxUploadingFile: 0,
    };
  },

  computed: {
    ...mapState('Mixins/Studentwork', {
      ms_studentworkOssPolicy: 'studentworkOssPolicy',
      ms_assignmentId: 'assignmentId',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    ...mapGetters('Mixins/Studentwork', {
      mg_isAssignmentAttachmentFull: 'isAssignmentAttachmentFull',
    }),

    c_isNeedGetStudentworkpolicy() {
      return (
        !this.ms_studentworkOssPolicy.expire ||
        parseInt(this.ms_studentworkOssPolicy.expire) * 1000 <= new Date().getTime() + 2 * OSS_TIMER
      );
    },

    c_ossHost() {
      let host = this.ms_studentworkOssPolicy.host || '';
      return host.replace(/^http/, 'https');
    },
  },

  methods: {
    ...mapActions('Mixins/Studentwork', {
      ma_getStudentworkpolicy: 'getStudentworkpolicy',
      ma_newStudentwork: 'newStudentwork',
      ma_getStudentwork: 'getStudentwork',
      ma_deleteStudentwork: 'deleteStudentwork',
    }),

    ...mapActions('Mixins/MtEditor', {
      ma_uploadQaImg: 'uploadQaImg',
    }),

    getStudentworkpolicy() {
      if (this.c_isNeedGetStudentworkpolicy) {
        this.ma_getStudentworkpolicy();
      }
    },

    async uploadStudentwork(files) {
      for (
        this.idxUploadingFile = 0;
        this.idxUploadingFile < files.length;
        this.idxUploadingFile++
      ) {
        if (this.mg_isAssignmentAttachmentFull) {
          swalWarning('最多只能上传10个作业文件');
          break;
        }
        const file = files[this.idxUploadingFile];
        //console.log(file.type)
        //if (!file.type.match(/^image\/(gif|jpe?g|a?png|svg|webp|bmp|vnd\.microsoft\.icon)/i)) {
        //  swalWarning('只能上传图片格式文件');
        //  return;
        //}
        if (file.size > 50 * 1024 * 1024) {
          swalWarning('文件大小不能超过50MB');
          break;
        }
        const { accessid, policy, signature } = this.ms_studentworkOssPolicy;
        const key = `${this.mg_userInfo.studentId}/${file.name}`;
        let formData = new FormData();
        formData.append('OSSAccessKeyId', accessid);
        formData.append('policy', policy);
        formData.append('Signature', signature);
        formData.append('key', key);
        formData.append('success_action_status', 200);
        formData.append('file', file);
        try {
          await this.ma_uploadQaImg({
            url: this.c_ossHost,
            data: formData,
          });
          await this.ma_newStudentwork({
            assignmentId: this.ms_assignmentId,
            fileName: file.name,
          });
        } catch {
          swalWarning('哎呀，有作业保存失败了');
          break;
        }
      }
    },

    async getStudentwork(studentwork) {
      await this.ma_getStudentwork({
        fileName: studentwork.fileName,
      });
    },

    async deleteStudentwork(studentwork) {
      await this.ma_deleteStudentwork({
        assignmentId: this.ms_assignmentId,
        fileName: studentwork.fileName,
      });
    },
  },

  created() {
    this.getStudentworkpolicy();
    this.itvlStudentworkOssPolicy = setInterval(this.getStudentworkpolicy, OSS_TIMER);
  },

  beforeDestroy() {
    clearInterval(this.itvlStudentworkOssPolicy);
  },
};

export default StudentworkMixin;
